import { Calendar } from 'primereact/calendar'
import { ColumnFilterElementTemplateOptions } from 'primereact/column'

import i18n from '../../utils/i18n'

export const DateFilterTemplate = (
  options: ColumnFilterElementTemplateOptions,
) => {
  if (!options) return null

  const { language } = i18n

  function getDateFormat() {
    switch (language) {
      case 'de':
        return 'tt.mm.jjjj'
      case 'en':
        return 'mm/dd/yyyy'
      default:
        return 'mm/dd/yyyy'
    }
  }

  function getMaskFormat() {
    switch (language) {
      case 'de':
        return '99.99.9999'
      case 'en':
        return '99/99/9999'
      default:
        return '99/99/9999'
    }
  }
  return (
    <Calendar
      value={options.value}
      onChange={(e: any) => {
        options.filterCallback(e.value, options.index)
      }}
      mask={getMaskFormat()}
      placeholder={getDateFormat()}
      showButtonBar
      locale={language}
      showIcon={true}
    />
  )
}
